import { Box, ListItemButton, Typography } from '@mui/material';

import type { NotificationItem } from '@/types/notifications';
import { notificationCopy } from './notificationCopy';
import { formatNotificationTime } from './notificationTime';

interface NotificationRowProps {
  item: NotificationItem;
  onClick: (item: NotificationItem) => void;
}

export function NotificationRow({ item, onClick }: NotificationRowProps) {
  const copy = notificationCopy(item);
  const unread = !item.read_at;

  return (
    <ListItemButton
      onClick={() => onClick(item)}
      data-unread={unread}
      sx={{ alignItems: 'flex-start', gap: 1.5, py: 1.5 }}
    >
      <Box
        aria-hidden
        sx={{
          mt: 0.75,
          width: 8,
          height: 8,
          flexShrink: 0,
          borderRadius: '50%',
          bgcolor: unread ? 'primary.main' : 'transparent',
        }}
      />
      <Box sx={{ minWidth: 0, flex: 1 }}>
        {copy.label && (
          <Typography
            variant="caption"
            component="div"
            sx={{
              color: 'text.secondary',
            }}
          >
            {copy.label}
          </Typography>
        )}
        <Typography variant="body2" sx={{ fontWeight: unread ? 600 : 400 }}>
          {copy.title}
        </Typography>
        {copy.message && (
          <Typography
            variant="body2"
            sx={{
              color: 'text.secondary',
            }}
          >
            {copy.message}
          </Typography>
        )}
        <Typography
          variant="caption"
          sx={{
            color: 'text.secondary',
          }}
        >
          {formatNotificationTime(item.created_at)}
        </Typography>
      </Box>
    </ListItemButton>
  );
}
